import React from 'react';
import {Link} from 'react-router-dom';
import {
    Button,
    Form,
    Row,
    Col,
    Select,
    Input,
    Popconfirm,
    message,
} from 'antd';

const FormItem = Form.Item;
import {
    againAllHostIndex,
    restartServer,
    setAutoCutHostTomorrow,
    setAutoCutHostToday,
    getAutoCutHostToMorrow,
    getAutoCutHostToday,
    createPageAction,
    getHostList,
    createBulkStatusAction,
    createSetIpListAction,
    getServerInfo,
    getHttpServerInfo,
    changeServerStatus,
    bunchChangeStatus,
    createAddListStatusAction,
    createAddWorkListStatusAction,
    searchDataAction,
    restartHost,
    createStatusAction,
    restartWorker
} from './actions';
import {connect} from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');
const spans = {
    xs: 14,
    sm: 14,
    md: 6,
    lg: 6,
    xl: 6,
};

class Search extends React.Component {
    constructor(props) {
        super(props);
    }

    bulkUpdate() {
        const {ipList} = this.props;
        if (ipList === undefined || ipList.length == 0) {
            message.error('请先勾选再进行批量操作!!!');
            return;
        }
        this.props.changeBulkStatus(true);
    }

    showServeEdit = async () => {
        // 显示服务编辑页面
        console.log(this.props)
        await this.props.getServerInfo(); // 获取服务信息
        this.props.changeServerStatus({showServe: true}); // 显示弹窗
    }

    showHttpServeEdit = async () => {
        // 显示服务编辑页面
        console.log(this.props)
        await this.props.getHttpServerInfo(); // 获取服务信息
        this.props.changeServerStatus({showServe: true}); // 显示弹窗
    }
    
    addHostList() {
        this.props.changeAddListStatus(true);
    }

    addWorkHostList() {
        this.props.changeAddWorkListStatus(true);
    }

    addHost() {
        this.props.changeStatus(2);
    }

    restartList(attr) {
        const {ipList} = this.props;
        if (ipList === undefined || ipList.length == 0) {
            message.error('请先勾选再进行批量操作!!!');
            return;
        }
        this.props[attr](ipList)
            .then(() => {
                this.props.getHostList();
                message.success('批量重启操作成功!!!');
                this.props.setIpList([]);
            })
            .catch(e => {
                this.props.setIpList([]);
                message.error('批量重启操作失败!!!');
            });
    }

    componentDidMount() {
        this.props.getAutoCutHostToMorrow();
        this.props.getAutoCutHostToday();
    }

    async todayDel() {
        await this.props.setAutoCutHostToday(!this.props.todayDel);
        this.props.getAutoCutHostToday();
    }

    async toMorrowAdd() {
        await this.props.setAutoCutHostTomorrow(!this.props.tomorrowAdd);
        this.props.getAutoCutHostToMorrow();
    }

    async  againAllHostIndex() {
        await  this.props.againAllHostIndex();
        this.props.resetPagination();
        this.props.getHostList();
        message.info('请一分钟后刷新结果!');
    }

    bunchChangeStatus(value) {
        const {ipList} = this.props;
        if (ipList === undefined || ipList.length == 0) {
            message.error('请先勾选再进行批量删除操作!!!');
            return;
        }
        this.props
            .bunchChangeStatus(ipList, value)
            .then(() => {
                this.props.setIpList([]);
                message.success('批量删除成功!!!');
                this.props.getHostList();
            })
            .catch(e => {
                this.props.setIpList([]);
                message.error('批量删除失败!!!');
            });
    }

    restartServer(f) {
        this.props.restartServer(f);
    }

    handleReset = () => {
        this.props.form.resetFields();
    }

    // 查询
    handleSearch = () => {
        let values = this.props.form.getFieldsValue();
        for (let i in values) {
            if (values[i] == -1 || values[i] === '' || values[i] === undefined) {
                delete values[i];
            }
        }
        console.log('=====searchValue', values);
        this.props.changeSearchValues(values);
        this.props.resetPagination();
        this.props.getHostList();
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        return (
            <div>
                <h2 style={{marginBottom: '20px'}}>机器管理</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{marginBottom: '10px'}}>
                        <Col span={6}>
                            <FormItem {...spans} label="ip">
                                {getFieldDecorator('ip')(<Input placeholder="请填写" style={{width: '100%'}}/>)}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem {...spans} label="机器分组ID">
                                {getFieldDecorator('groupId')(<Input placeholder="请填写" style={{width: '100%'}}/>)}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="状态" {...spans}>
                                {getFieldDecorator('status')(
                                    <Select allowClear placeholder="全部" style={{width: '120px'}}>
                                        <Option key='0' value='-1'>
                                            全部
                                        </Option>
                                        <Option key='1' value={true}>
                                            在线
                                        </Option>
                                        <Option key='2' value={false}>
                                            下线
                                        </Option>
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{textAlign: 'center', marginTop: '10px', marginBottom: '20px'}}>
                            <Button style={{margin: '0 8px'}} onClick={this.handleReset}>
                                重置
                            </Button>
                            <Button type="primary" onClick={this.handleSearch} style={{margin: '0 8px'}}>
                                搜索
                            </Button>
                            <Button type="primary" onClick={() => this.addWorkHostList()}
                                    style={{margin: '0 8px'}}>创建worker机器</Button>
                            <Button type="primary" onClick={() => this.restartList('restartWorker')}
                                    style={{margin: '0 8px'}}>批量重启worker</Button>
                            <Button type="primary" onClick={() => this.restartList('restartHost')}
                                    style={{margin: '0 8px'}}>批量重启服务器</Button>
                            <Button type="primary" onClick={() => this.bulkUpdate()}
                                    style={{margin: '0 8px'}}>批量更新</Button>
                            <Popconfirm
                                style={{margin: '0 8px'}}
                                title="确定批量删除？"
                                onConfirm={() => this.bunchChangeStatus(2)}
                                onCancel={this.cancel}
                                okText="确定"
                                cancelText="取消"
                                className="bunch_off">
                                <Button type="primary">
                                    批量删除
                                </Button>
                            </Popconfirm>
                            <Button type="primary" onClick={() => this.addHostList()} style={{ margin: '0 8px' }}>批量添加</Button>
                            <Button type="primary" onClick={() => this.addHost()} style={{margin: '0 8px'}}>添加</Button>
                            <Button type="primary" onClick={() => this.todayDel()}
                                    style={{margin: '0 8px'}}>今日减机器({this.props.todayDel == true ? '已打开' : '已关闭'})</Button>
                            <Button type="primary" onClick={() => this.toMorrowAdd()}
                                    style={{margin: '0 8px'}}>明日增机器({this.props.tomorrowAdd == true ? '已打开' : '已关闭'})</Button>
                            <Popconfirm
                                style={{margin: '0 8px'}}
                                title="确定重启？"
                                onConfirm={() => this.restartServer(0)}
                                onCancel={this.cancel}
                                okText="确定"
                                cancelText="取消"
                                className="bunch_off">
                                <Button type="primary">
                                    重启server
                                </Button>
                            </Popconfirm>

                            

                            <Button type="primary" onClick={this.showServeEdit}
                                    style={{margin: '0 8px'}}>编辑server</Button>

                            <Popconfirm
                                style={{margin: '0 8px'}}
                                title="确定重启？"
                                onConfirm={() => this.restartServer(1)}
                                onCancel={this.cancel}
                                okText="确定"
                                cancelText="取消"
                                className="bunch_off">
                                <Button type="primary">
                                    重启HttpServer
                                </Button>
                            </Popconfirm>

                            <Button type="primary" onClick={this.showHttpServeEdit}
                                    style={{margin: '0 8px'}}>编辑HttpServer</Button>

                            <Popconfirm
                                style={{margin: '0 8px'}}
                                title="确定要重新排序机器,任务执行顺序将被打乱!  "
                                onConfirm={() => this.againAllHostIndex()}
                                onCancel={this.cancel}
                                okText="确定"
                                cancelText="取消"
                                className="bunch_off">
                                <Button type="primary">
                                    重新排序机器
                                </Button>
                            </Popconfirm>

                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ipList: state.hostList.ipList,
    todayDel: state.hostList.todayDel,
    tomorrowAdd: state.hostList.tomorrowAdd,
    todayDelStatus: state.hostList.todayDelStatus,
    tomorrowAddStatus: state.hostList.tomorrowAddStatus,
});

const mapDispatchToProps = dispatch => ({
    changeSearchValues: values => dispatch(searchDataAction(values)),
    resetPagination: () => dispatch(createPageAction({page: 1})),
    getHostList: () => dispatch(getHostList()),
    changeBulkStatus: status => dispatch(createBulkStatusAction(status)),
    setIpList: list => dispatch(createSetIpListAction(list)),
    getServerInfo: () => dispatch(getServerInfo()),
    getHttpServerInfo:()=>dispatch(getHttpServerInfo()),
    changeServerStatus: prarms => dispatch(changeServerStatus(prarms)),
    bunchChangeStatus: (ipList, type) => dispatch(bunchChangeStatus(ipList, type)),
    changeAddListStatus: status => dispatch(createAddListStatusAction(status)),
    changeAddWorkListStatus: status => dispatch(createAddWorkListStatusAction(status)),
    restartHost: prarms => dispatch(restartHost(prarms)),
    changeStatus: status => dispatch(createStatusAction(status)),
    restartWorker: params => dispatch(restartWorker(params)),
    getAutoCutHostToday: () => dispatch(getAutoCutHostToday()),
    getAutoCutHostToMorrow: () => dispatch(getAutoCutHostToMorrow()),
    setAutoCutHostToday: (prarms) => dispatch(setAutoCutHostToday(prarms)),
    setAutoCutHostTomorrow: (prarms) => dispatch(setAutoCutHostTomorrow(prarms)),
    restartServer: (f) => dispatch(restartServer(f)),
    againAllHostIndex: () => dispatch(againAllHostIndex()),

});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Search));



// WEBPACK FOOTER //
// ./pages/assist/hostManage/search.js